<mat-select disableOptionCentering [formControl]="$any(formControl)" [formlyAttributes]="field"
    [tabIndex]="to?.tabindex" (closed)="optionSearchControl.setValue(null)" [compareWith]="compareWithFn" [disabled]="field.formControl.value">
    <input [style.visibility]="!to.search ? 'hidden' : 'visible' " autocomplete="off" matInput class="searchInput"
        placeholder="search" [formControl]="optionSearchControl" #searchText>
    <mat-option
        *ngFor="let option of ((filteredOptions?.length ? asObservable(filteredOptions) :  asObservable(to.options) ) | async )"
        [value]="this.field.templateOptions.useOption ? option : option[valueProp]">
        {{option[labelProp]}}
    </mat-option>
</mat-select>